import { useEffect, useRef, useState } from "react";
import { fromLonLat } from "ol/proj";
import { request } from "../../../../../request";
import View from "ol/View";
import { Map } from "ol";

export function useSearch(map: Map | null) {
	const [currentSearch, setCurrentSearch] = useState("");

	const timerRef = useRef(-1); // debounce

	useEffect(() => {
		clearTimeout(timerRef.current);

		function executeGeoSearch() {
			if (currentSearch.length > 0 && map) {
				// Use OpenStreetMap Nominatim to get the coordinates
				let geocodeUrl =
					"https://nominatim.openstreetmap.org/search?format=json&q=" +
					encodeURIComponent(currentSearch+ ", Illinois, United States");
				request(geocodeUrl)
					.then(function ({ data }) {
						if (data.length > 0) {
							let lon = parseFloat(data[0].lon);
							let lat = parseFloat(data[0].lat);
							let view = new View({
								center: fromLonLat([lon, lat]),
								zoom: 12,
							});
							map.setView(view);
						}
					})
					.catch(function (error) {
						console.error("Error:", error);
					});
			}
		}

		timerRef.current = window.setTimeout(executeGeoSearch, 200);
	}, [map, currentSearch]);

	return { currentSearch, setCurrentSearch };
}